//TODO: remove unused
import axios from "axios";
// import Cart from './cart.js'

const v = "1.0.5";

const DEVICE = window.matchMedia("(max-width: 999px)").matches
  ? "mobile"
  : "desktop";
const menuHeight = 91;

class Investment {
  constructor() {
    this.navmode = "#td";

    this.selected = false;
    // this.bodyTop  = 0;
    if (localStorage.getItem("kfx_building_details")) {
      let tmp = JSON.parse(localStorage.getItem("kfx_building_details"));
      this.active_floor = tmp.floor;
      this.active_building = tmp.building;
    } else {
      this.active_floor = 0;
      this.active_building = "A";
    }

    if (localStorage.getItem("kfx_building_details_b")) {
      let tmp = JSON.parse(localStorage.getItem("kfx_building_details_b"));
      this.active_b_floor = tmp.floor;
      this.active_b_building = tmp.building;
    } else {
      this.active_b_floor = 0;
      this.active_b_building = "B";
    }

    if (localStorage.getItem("kfx_active_basement_type")) {
      let tmp = JSON.parse(localStorage.getItem("kfx_active_basement_type"));
      if (Number(tmp.A > 2)) Object.assign(tmp, { A: 1 });
      if (Number(tmp.B > 2)) Object.assign(tmp, { B: 1 });
      this.active_basement_type = {
        A: tmp.A,
        B: tmp.B,
      };
    } else {
      this.active_basement_type = {
        A: 1,
        B: 1,
      };
    }

    this.canvas = document.querySelector("#building_area");
    this.v2canvas = document.querySelector("#building_picker");

    this.ctx = this.canvas.getContext("2d");
    this.ctx.save();

    if (this.v2canvas) {
      this.v2ctx = this.v2canvas.getContext("2d");
      this.v2ctx.save();
    }

    if (document.querySelector("#floor")) {
      this.mode = "full";
      this.floor = {
        A: document.querySelector("#floor"),
        B: document.querySelector("#floorB"),
      };

      this.basement = {
        A: document.querySelector("#basement_a1"),
        B: document.querySelector("#basement_b1"),
      };

      this.floor_nav = document.querySelectorAll(".floor-item");
      this.basement_nav = document.querySelectorAll(".basement-item");

      // this.building_nav = document.querySelectorAll('.building-item');

      this.steps = [
        document.querySelector(".floor_picker"),
        document.querySelector(".flat-picker"),
      ];

      //nav listeners
      this.navListener();
      // this.navBuildingListener();
    } else {
      this.mode = "shortcode";
    }

    this.floors = {
      A: {
        0: "622,430, 840,451, 1306,412, 1306,438, 843,506, 622,470",
        1: "620,375, 840,379, 1306,371, 1306,411, 840,450, 620,429",
        2: "620,321, 840,309, 1306,333, 1306,370, 840,378, 620,376",
        3: "620,269, 840,240, 1306,295, 1306,332, 840,308, 620,320",
        4: "620,187, 840,130, 980,163, 980,171, 1022,181, 1045,178, 1133,198, 1133,205, 1153,203, 1183,209, 1183,215, 1218,224, 1239,222, 1294,235, 1294,273, 1299,273, 1299,280, 1306,281, 1306,294, 840,239, 620,268",
      },
      B: {
        0: "48,427, 220,439, 619,410, 619,438, 220,481, 48,463",
        1: "47,373, 220,376, 619,371, 619,409, 220,438, 47,426",
        2: "47,324, 220,315, 619,334, 619,370, 220,375, 47,372",
        3: "47,272, 220,254, 619,297, 619,333, 220,314, 47,323",
        4: "47,195, 216,164, 484,216, 484,220, 494,223, 509,222, 546,229, 546,232, 577,240, 591,239, 619,243, 619,296, 222,253, 47,271",
      },
    };

    this.v2_buildings = {
      A: "537,539, 641,261, 726,293, 622,572",
      B: "802,206, 895,204, 902,610, 809,612",
    };

    this.shapes = [];
    this.v2shapes = [];

    //canvas handling
    this.renderShapes();
    this.canvasListener();

    if (this.v2canvas) {
      this.v2renderShapes();
      this.v2canvasListener();
    }

    //initializes script
    this.changeFloor(this.active_building, this.active_floor);
    this.changeFloor(this.active_b_building, this.active_b_floor);

    this.changeBasement("A", this.active_basement_type.A);
    this.changeBasement("B", this.active_basement_type.B);

    this.navbarHandler();
  }

  /*
   * Creates shapes
   */
  renderShapes() {
    for (let [key, building] of Object.entries(this.floors)) {
      for (let [k, floor] of Object.entries(building)) {
        let color =
          key == "B" ? "rgba(0, 79, 183, 0.6)" : "rgba(65, 190, 255, 0.6)";
        this.shapes.push(new Shape(`${key}:${k}`, floor.split(","), color));
      }
    }
  }

  /*
   * Adds listeners to canvas
   */
  canvasListener() {
    let visible;
    this.canvas.addEventListener("mousemove", (e) => {
      let { x, y } = e;
      let rect = this.canvas.getBoundingClientRect();

      let ratio =
        parseFloat(this.canvas.getAttribute("width")) / parseFloat(rect.width);
      // console.log( parseInt( this.canvas.getAttribute('height') ) / parseInt( rect.height ) )
      // console.log( ratio )
      // console.log( `x: ${x - rect.left}`)
      // console.log( `${x - rect.left} * ${ratio}`)
      // console.log( `x1: ${parseFloat(x - rect.left) * parseFloat(ratio)}`)
      // console.log( `y: ${y - rect.top}`)
      // console.log( 'should be: x: 620, y: 268')

      visible = false;
      for (let shape of this.shapes) {
        let hit = shape.hitTest(
          this.ctx,
          parseFloat(x - rect.left) * parseFloat(ratio),
          parseFloat(y - rect.top) * parseFloat(ratio)
        );
        if (hit) {
          this.canvas.style.cursor = "pointer";
        } else {
          this.canvas.style.cursor = "auto";
        }
        if (hit && !visible) {
          // console.log( shape.color )
          if (visible != shape.id) {
            // name.innerText = '';
            this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
          }
          this.ctx.fillStyle = shape.color;
          this.ctx.fill();
          // name.innerText = shape.id;

          visible = shape.id;
          break;
        }
      }

      if (!visible) {
        // name.innerText = '';
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
      }
    });

    this.canvas.addEventListener("click", (e) => {
      let { x, y } = e;

      let rect = this.canvas.getBoundingClientRect();
      let ratio =
        parseFloat(this.canvas.getAttribute("width")) / parseFloat(rect.width);

      for (let shape of this.shapes) {
        let hit = shape.hitTest(
          this.ctx,
          parseFloat(x - rect.left) * parseFloat(ratio),
          parseFloat(y - rect.top) * parseFloat(ratio)
        );
        if (hit) {
          // this.ctx.fillStyle = shape.color;
          // this.ctx.fill();
          let info = shape.id.split(":");

          this.changeFloor(info[0], info[1]);

          if (this.mode == "shortcode") {
            window.location.href = `${SITE_URL}/mieszkania#pietro`;
          } else {
            let cords = document
              .querySelector(`#building_cnt_${info[0]}`)
              .getBoundingClientRect();

            window.scroll({
              top: cords.top + window.scrollY - menuHeight,
              left: window.scrollX,
              behavior: "smooth",
            });
          }
        }
      }
    });
  }

  /**
   * Creates shapes for building picker
   */
  v2renderShapes() {
    for (let [key, building] of Object.entries(this.v2_buildings)) {
      let color =
        key == "B" ? "rgba(0, 79, 183, 0.6)" : "rgba(65, 190, 255, 0.6)";
      this.v2shapes.push(new Shape(`${key}`, building.split(","), color));
    }
  }

  /**
   * Adds listeners to second canvas
   */
  v2canvasListener() {
    let visible;
    let showed_image = null;
    this.v2canvas.addEventListener("mousemove", (e) => {
      let { x, y } = e;
      let rect = this.v2canvas.getBoundingClientRect();

      let ratio =
        parseFloat(this.v2canvas.getAttribute("width")) /
        parseFloat(rect.width);

      visible = false;

      for (let shape of this.v2shapes) {
        let hit = shape.hitTest(
          this.v2ctx,
          parseFloat(x - rect.left) * parseFloat(ratio),
          parseFloat(y - rect.top) * parseFloat(ratio)
        );
        if (hit) {
          this.v2canvas.style.cursor = "pointer";
          let img = new Image();
          img.src = `${rest.theme_link}/building/${shape.id}_c2a.png?v=${v}`;
          let pos = {
            A: {
              x: 40,
              y: 306,
            },
            B: {
              x: 1045,
              y: 398,
            },
          };
          if (img != showed_image) {
            img.onload = () => {
              this.v2ctx.drawImage(img, pos[shape.id].x, pos[shape.id].y);
              showed_image = img;
            };
          }
        } else {
          showed_image = null;
          this.v2canvas.style.cursor = "auto";
        }
        if (hit && !visible) {
          // console.log( shape.color )
          if (visible != shape.id) {
            // name.innerText = '';
            this.v2ctx.clearRect(
              0,
              0,
              this.v2canvas.width,
              this.v2canvas.height
            );
          }
          this.v2ctx.fillStyle = shape.color;
          this.v2ctx.fill();
          // name.innerText = shape.id;

          visible = shape.id;
          break;
        }
      }

      if (!visible) {
        // name.innerText = '';
        this.v2ctx.clearRect(0, 0, this.v2canvas.width, this.v2canvas.height);
      }
    });

    this.v2canvas.addEventListener("click", (e) => {
      let { x, y } = e;

      let rect = this.v2canvas.getBoundingClientRect();
      let ratio =
        parseFloat(this.v2canvas.getAttribute("width")) /
        parseFloat(rect.width);

      for (let shape of this.v2shapes) {
        let hit = shape.hitTest(
          this.v2ctx,
          parseFloat(x - rect.left) * parseFloat(ratio),
          parseFloat(y - rect.top) * parseFloat(ratio)
        );
        if (hit) {
          // this.ctx.fillStyle = shape.color;
          // this.ctx.fill();

          this.changeFloor(shape.id, this.active_floor);

          if (this.mode == "shortcode") {
            window.location.href = `${SITE_URL}/mieszkania#pietro`;
          } else {
            let cords = document
              .querySelector(`#building_cnt_${shape.id}`)
              .getBoundingClientRect();

            window.scroll({
              top: cords.top + window.scrollY - menuHeight,
              left: window.scrollX,
              behavior: "smooth",
            });
          }
        }
      }
    });
  }

  /*
   * Adds listeners to side navbar
   */
  navListener() {
    this.floor_nav.forEach((nav) => {
      nav.addEventListener("click", () => {
        //breakpoint 1
        this.changeFloor(
          nav.getAttribute("data-building"),
          nav.getAttribute("data-floor")
        );
      });
    });

    this.basement_nav.forEach((nav) => {
      nav.addEventListener("click", () => {
        this.changeBasement(
          nav.getAttribute("data-building"),
          nav.getAttribute("data-type")
        );
      });
    });
  }

  /*
   * Adds listeners to building navbar
   */
  navBuildingListener() {
    this.building_nav.forEach((nav) => {
      nav.addEventListener("click", () => {
        this.changeFloor(nav.getAttribute("data-building"), this.active_floor);
      });
    });
  }

  /*
   * Changes floor
   */
  changeFloor(building, floor) {
    this.active_floor = floor;
    this.active_building = building;

    if (building == "A") {
      localStorage.setItem(
        "kfx_building_details",
        JSON.stringify({ floor: floor, building: building })
      );
    } else {
      localStorage.setItem(
        "kfx_building_details_b",
        JSON.stringify({ floor: floor, building: building })
      );
    }

    if (this.mode == "full") {
      let path =
        this.floor[building].getAttribute("data-basepath") +
        building +
        floor +
        ".svg?v=" +
        v;
      this.floor[building].setAttribute("data", path);
      this.floor[building].onload = () => {
        axios
          .get(
            `${rest.url}investment/v2/get-locals?building=${building}&floor=${floor}`
          )
          .then((res) => {
            res.data.forEach((local) => {
              let place = JSON.parse(local.position);
              this.renderStatus(
                parseInt(local.status),
                place,
                local.id,
                local.name,
                building
              );
            });
          });
      };

      this.floor_nav.forEach((el) => {
        if (el.getAttribute("data-building") == building) {
          if (el.getAttribute("data-floor") == floor) {
            el.classList.add("active");
          } else {
            el.classList.remove("active");
          }
        }
      });

      // document.querySelector('#building_id').innerText = building == 'A' ? building : 'B';
      // this.building_nav.forEach( el => {
      //   if( el.getAttribute('data-building') == building ){
      //     el.classList.add('active')
      //   }else{
      //     el.classList.remove('active')
      //   }
      // })

      // WARNING: only for Kopernika 16 purposes
      // if( building == "BC" ){
      //   document.querySelector('.flat-wraper').classList.add('BC')
      // }else{
      //   document.querySelector('.flat-wraper').classList.remove('BC')
      // }
    }
  }

  renderStatus(status, place, id, name = null, building) {
    if (place) {
      let floor = this.floor[building].contentDocument;
      let elements = [];
      if (place.points) {
        elements = Object.values(
          floor.querySelectorAll("polygon") ?? {}
        ).filter((polygon) => polygon.getAttribute("points") == place.points);
      } else {
        elements = Object.values(floor.querySelectorAll("rect") ?? {}).filter(
          (polygon) =>
            (polygon.getAttribute("x") == place.x &&
              polygon.getAttribute("y") == place.y &&
              polygon.getAttribute("width") == place.width &&
              polygon.getAttribute("height") == place.height) ||
            polygon.getAttribute("data-name") == place.name
        );
        if (elements.length == 0) {
          elements = Object.values(floor.querySelectorAll("path") ?? {}).filter(
            (polygon) => polygon.getAttribute("data-name") == place.name
          );
        }
      }

      elements.forEach((el) => {
        let s = this.parseStatus(status);
        el.style.fill = s.color;
        el.style.opacity = s.opacity;
        el.style.cursor = status >= 3 ? "not-allowed" : "pointer";
        el.setAttribute("id", id);

        if (name) {
          let prevent_since = {};
          el.onmousemove = (event) => {
            let tooltip =
              this.floor[building].parentNode.querySelector(".flat-tooltip");
            let rect = tooltip.getBoundingClientRect();

            tooltip.innerHTML = status >= 3 ? "Niedostępne" : name;
            tooltip.style.display = "block";
            if (!prevent_since[name] && rect.width < 150) {
              prevent_since[name] = event.pageX + 30;
            }

            tooltip.style.left =
              event.pageX > prevent_since[name]
                ? `${event.pageX - rect.width + 30}px`
                : `${event.pageX}px`;
            tooltip.style.top = `${event.pageY}px`;
          };
          el.onmouseout = () => {
            let tooltip =
              this.floor[building].parentNode.querySelector(".flat-tooltip");
            tooltip.style.display = "none";
          };
        }
      });
    }
  }

  changeBasement(building, type) {
    this.active_basement_type[building] = type;

    let tmp = JSON.parse(localStorage.getItem("kfx_active_basement_type"));

    if (!tmp) {
      tmp = {
        A: 1,
        B: 1,
      };
    }

    if (Number(tmp.A > 2)) Object.assign(tmp, { A: 1 });
    if (Number(tmp.B > 2)) Object.assign(tmp, { B: 1 });
    tmp[building] = type;
    localStorage.setItem("kfx_active_basement_type", JSON.stringify(tmp));

    if (this.mode == "full") {
      [1].forEach((i) => {
        let path =
          this.basement[building].getAttribute("data-basepath") +
          type +
          ".svg?v=" +
          v;
        this.basement[building].setAttribute("data", path);
        this.basement[building].onload = () => {
          axios
            .get(
              `${rest.url}investment/v2/get-locals?building=${building}&floor=-${type}&type=basement`
            )
            .then((res) => {
              res.data.forEach((local) => {
                let place = JSON.parse(local.position);
                this.renderBasementStatus(
                  parseInt(local.status),
                  place,
                  local.id,
                  local.name,
                  building,
                  i
                );
              });
            });
        };
      });

      this.basement_nav.forEach((el) => {
        if (el.getAttribute("data-building") == building) {
          if (el.getAttribute("data-type") == type) {
            el.classList.add("active");
          } else {
            el.classList.remove("active");
          }
        }
      });

      // document.querySelector('#building_id').innerText = building == 'A' ? building : 'B';
      // this.building_nav.forEach( el => {
      //   if( el.getAttribute('data-building') == building ){
      //     el.classList.add('active')
      //   }else{
      //     el.classList.remove('active')
      //   }
      // })

      // WARNING: only for Kopernika 16 purposes
      // if( building == "BC" ){
      //   document.querySelector('.flat-wraper').classList.add('BC')
      // }else{
      //   document.querySelector('.flat-wraper').classList.remove('BC')
      // }
    }
  }

  renderBasementStatus(status, place, id, name = null, building, b_floor) {
    if (place) {
      let floor = this.basement[building].contentDocument;

      let elements = [];
      if (place.points) {
        elements = Object.values(
          floor.querySelectorAll("polygon") ?? {}
        ).filter((polygon) => polygon.getAttribute("points") == place.points);
      } else {
        elements = Object.values(
          floor.querySelectorAll("rect, path") ?? {}
        ).filter((polygon) => polygon.getAttribute("id") == place.id);
        if (elements.length == 0) {
          elements = Object.values(floor.querySelectorAll("rect") ?? {}).filter(
            (polygon) =>
              (polygon.getAttribute("x") == place.x &&
                polygon.getAttribute("y") == place.y &&
                polygon.getAttribute("width") == place.width &&
                polygon.getAttribute("height") == place.height) ||
              polygon.getAttribute("data-name") == place.name
          );
          if (elements.length == 0) {
            elements = Object.values(
              floor.querySelectorAll("path") ?? {}
            ).filter(
              (polygon) => polygon.getAttribute("data-name") == place.name
            );
          }
        }
      }

      elements.forEach((el) => {
        let s = this.parseStatus(status);
        el.style.fill = s.color;
        el.style.opacity = s.opacity;
        el.style.cursor = "pointer";
        el.setAttribute("id", id);

        if (name) {
          let prevent_since = {};
          el.onmousemove = (event) => {
            let tooltip =
              this.basement[building].parentNode.querySelector(".flat-tooltip");
            let rect = tooltip.getBoundingClientRect();

            const { width } = this.basement[building].getBoundingClientRect();

            tooltip.innerHTML = status >= 3 ? "Niedostępne" : name;
            tooltip.style.display = "block";
            if (!prevent_since[name] && rect.width < 150) {
              prevent_since[name] = event.pageX - 100;
            }

            tooltip.style.left =
              event.pageX > width / 2
                ? `${event.pageX - rect.width + 30}px`
                : `${event.pageX}px`;
            tooltip.style.top = `${event.pageY}px`;
          };
          el.onmouseout = () => {
            let tooltip =
              this.basement[building].parentNode.querySelector(".flat-tooltip");
            tooltip.style.display = "none";
          };
        }
      });
    }
  }

  parseStatus(status) {
    let value = {};
    value.opacity = 0.4;
    switch (status) {
      case 1:
        value.class = "available";
        value.color = "#4EBE4A";
        break;
      case 2:
        value.class = "reserved";
        value.color = "#6BB8E1";
        break;
      case 3:
      case 5:
      case 6:
      case 7:
      case 8:
        value.class = "sold";
        value.color = "#EE5740";
        break;
    }
    return value;
  }

  /**
   * Handling main navbar
   */
  navbarHandler() {
    let tabs = document.querySelectorAll(".picker-type ul li a");

    tabs.forEach((tab) => {
      tab.onclick = () => {
        this.navmode = tab.getAttribute("href");
        this.navbarLisener(tab, tabs, true);
      };
    });
    this.navbarLisener(tabs[0], tabs);
  }

  /**
   * Handling event listeners for navbar
   * @param Object elem html entity
   * @param Array tabs array of html objects
   * @param Boolean clicked
   */
  navbarLisener(elem, tabs, clicked = false) {
    tabs.forEach((tab) => {
      if (tab.getAttribute("href") !== this.navmode) {
        tab.classList.remove("active");
        // if( tab.getAttribute('href') !== '#list'){
        //   document.querySelector(tab.getAttribute('href')).style.display = "none";
        // }
      } else {
        tab.classList.add("active");
        // if( tab.getAttribute('href') !== '#list'){
        //   document.querySelector(tab.getAttribute('href')).style.display = "block";
        // }

        if (clicked) {
          let anchor = document.querySelector(tab.getAttribute("href"));
          let cords = anchor.getBoundingClientRect();
          window.scroll({
            top: cords.top + window.scrollY - menuHeight,
            left: window.scrollX,
            behavior: "smooth",
          });
        }
      }
    });
  }
}

function Shape(id, points, color) {
  this.id = id;
  this.points = points;
  this.color = color;
}

Shape.prototype.hitTest = function (ctx, x, y) {
  ctx.beginPath();
  ctx.moveTo(this.points[0], this.points[1]);
  for (let i = 2; i < this.points.length; i += 2) {
    ctx.lineTo(this.points[i], this.points[i + 1]);
  }

  ctx.closePath();

  return ctx.isPointInPath(x, y);
};

export default Investment;
